import React, { useEffect, useState } from "react";
import { api, buildMediaUrl } from "../lib/api";
import { useLang } from "../contexts/LanguageContext";
import SectionHeader from "../components/SectionHeader";

export default function MediaLibrary() {
  const { t } = useLang();
  const [items, setItems] = useState([]);
  const [kind, setKind] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    api
      .get("/media", { params: { kind: kind || undefined, limit: 80 } })
      .then(({ data }) => setItems(data.items || []))
      .finally(() => setLoading(false));
  }, [kind]);

  return (
    <div data-testid="media-page">
      <SectionHeader
        eyebrow="Archive"
        title={t.sections.media_title}
        subtitle={t.sections.media_sub}
      />
      <div className="max-w-[1400px] mx-auto px-5 lg:px-10 py-12">
        <div className="flex flex-wrap items-center gap-2 mb-8 border-b border-slate200 pb-6">
          {[
            { v: "", l: t.filters.all },
            { v: "image", l: "Images" },
            { v: "video", l: "Videos" },
            { v: "pdf", l: "PDF" },
          ].map((k) => (
            <button
              key={k.v}
              data-testid={`media-filter-${k.v || "all"}`}
              onClick={() => setKind(k.v)}
              className={`px-3 h-9 text-[12px] uppercase tracking-widest border ${
                kind === k.v ? "bg-ink text-white border-ink" : "border-slate200 text-slate600 hover:border-ink hover:text-ink"
              }`}
            >
              {k.l}
            </button>
          ))}
        </div>

        {loading ? (
          <div className="text-slate500 py-20 text-center">{t.common.loading}</div>
        ) : items.length === 0 ? (
          <div className="text-slate500 py-20 text-center">{t.common.no_results}</div>
        ) : (
          <div className="grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
            {items.map((m) => (
              <MediaTile key={m.id} m={m} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

function MediaTile({ m }) {
  const url = buildMediaUrl(m.public_url);
  if (m.kind === "image" || (m.content_type || "").startsWith("image/")) {
    return (
      <a href={url} target="_blank" rel="noreferrer" className="tile block aspect-square overflow-hidden">
        <img src={url} alt={m.original_filename} className="w-full h-full object-cover" />
      </a>
    );
  }
  if (m.kind === "video" || (m.content_type || "").startsWith("video/")) {
    return (
      <div className="tile aspect-square overflow-hidden">
        <video src={url} controls className="w-full h-full object-cover" />
      </div>
    );
  }
  return (
    <a href={url} target="_blank" rel="noreferrer" className="tile p-5 flex flex-col gap-2 aspect-square justify-between">
      <div className="label-eyebrow text-ink">{m.kind || "FILE"}</div>
      <div className="text-[13px] text-slate700 break-words">{m.original_filename}</div>
      <div className="text-[11px] text-slate500 uppercase">{(m.size / 1024).toFixed(1)} KB</div>
    </a>
  );
}
